if (!customElements.get('predictive-search')) {
    class PredictiveSearch extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');
        this.clearButton = this.querySelector('.header-search--reset');
  
        this.input.addEventListener('input', this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this));
  
        this.clearButton.addEventListener('click', () => {
          this.clear()
        })
  
        this.clearButton.addEventListener('keydown', (event) => {
          if (event.keyCode == '13' || event.key == 'Enter') { //up
            this.clear()
          }
        })      
      }
  
      onChange() {
        const searchTerm = this.input.value.trim();
        if (!searchTerm.length) {
          this.close();
          return;
        }
        this.getSearchResults(searchTerm);
      }
  
      getSearchResults(searchTerm) {
        fetch(`${routes.predictive_search_url}?q=${searchTerm}&resources[type]=product,page,article&resources[limit]=10&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
          }
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
      }
  
      clear() {
        this.input.value = ""
        if (this.predictiveSearchResults) {
          this.predictiveSearchResults.style.display = 'none';
        }
      }
  
      open() {
        this.predictiveSearchResults.style.display = 'block';
      }
  
      close() {
        this.predictiveSearchResults.style.display = 'none';
      }
  
      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    }
  
    customElements.define('predictive-search', PredictiveSearch);
  }
